import { TUser } from '../types';
import { USER_DATA_KEY } from '../utils/constants';

const setUser = (userData: TUser) => {
  localStorage.setItem(USER_DATA_KEY, JSON.stringify(userData));
};

const clearUser = () => {
  localStorage.removeItem(USER_DATA_KEY);
};

const getUser = () => {
  let userData: TUser = undefined;

  try {
    userData = JSON.parse(localStorage.getItem(USER_DATA_KEY));
  } catch (e) {
    console.error(e);

    return undefined;
  }

  return userData;
};

export const userStore = () => ({
  setUser,
  getUser,
  clearUser
});
